import { IconSprite360Thick, IconSpritePhotoCamera, IconSpritePlayThick } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { stringToggle } from 'common/helper/string/toggle';
import { PropertyCardIconGroupTemplatePropsInterface } from 'common/module/property/card/icon-group/template-props.interface';

export const PropertyCardIconGroupTemplate: FunctionalComponent<PropertyCardIconGroupTemplatePropsInterface> = ({
  iconOptions = {
    360: {
      isEnabled: true,
    },
    images: {
      isEnabled: true,
    },
    video: {
      isEnabled: true,
    },
  },
  isTooltipsDisabled,
  ...props
}) => (
  <div
    className={`card-icon-group
    ${stringToggle('card-icon-group--disabled')(props.isDisabled)}
    ${props.class || ''}
  `}
  >
    {iconOptions?.images?.isEnabled && (
      <div className='card-icon-group__item'>
        <IconSpritePhotoCamera />
        <span className='card-icon-group__text'>{props.property.meta.images_count || 0}</span>
      </div>
    )}
    {iconOptions?.['360']?.isEnabled && props.property.view_360 && (
      <div className='card-icon-group__item'>
        <IconSprite360Thick />
        {!isTooltipsDisabled && (
          <div className='tooltip2 tooltip2--top'>
            <div className='tooltip2__content text text--normal card-list__tooltip-alignment'>
              <span>
                <span className='text text--bold'>{i18nTranslate('360 Tours')}</span>
                {` ${i18nTranslate('offer you a static panoramic view of the property.')}`}
              </span>
            </div>
          </div>
        )}
      </div>
    )}
    {iconOptions?.video?.isEnabled && props.property.meta?.video_metadata?.url && (
      <div className='card-icon-group__item'>
        <IconSpritePlayThick />
        {!isTooltipsDisabled && (
          <div className='tooltip2 tooltip2--top'>
            <div className='tooltip2__content text text--normal card-list__tooltip-alignment'>
              <span>
                <span className='text text--bold'>{i18nTranslate('Video Tours')}</span>
                {` ${i18nTranslate('are pre-recorded video walk-throughs of the property available at all times.')}`}
              </span>
            </div>
          </div>
        )}
      </div>
    )}
  </div>
);
